export const Centralhub = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.45898 9.79153H3.75187C4.49203 9.79153 5.14352 9.30339 5.35143 8.59303L7.09594 2.63263C7.21326 2.23179 7.78172 2.23362 7.89646 2.63521L12.0953 17.3311C12.2108 17.7354 12.7843 17.7336 12.8973 17.3287L14.6606 11.0102C14.8616 10.2898 15.5179 9.79153 16.2659 9.79153H18.5423"
      stroke="#A1A1AA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Centralhub
